export enum EPropertyMangerUrl {
  PROPERTY_MANAGER = 'property_manager/api/v2',
  PROPERTY_MANAGERS = 'property-managers',
}
